import LZString from 'lz-string';

const MAP_DATA_VERSION = 'map_v4';

const expire_time = () => {
  const one_month_milisecond = 43800 * 60 * 1000;
  return new Date().getTime() + one_month_milisecond;
};

export const cached_fetch = async (...args) => {
  const key = `${MAP_DATA_VERSION}__${args[0]}`;
  const store = require('store');
  const expirePlugin = require('store/plugins/expire');
  store.addPlugin(expirePlugin);
  store.removeExpiredKeys();
  const cached = await store.get(key);
  if (cached) {
    store.set(key, cached, expire_time());
    const res = LZString.decompress(cached);
    return new Response(res, {
      status: 200,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  const response = await fetch(...args);
  const data = response.clone();
  const json = await data.json();
  if (!json.error) {
    const string = JSON.stringify(json);
    const compress_res = LZString.compress(string);
    while (true) {
      try {
        store.set(key, compress_res, expire_time());
        break;
      } catch (err) {
        let keys = [];
        store.each((val, key) => {
          const expire_time = store.getExpiration(key);
          if (expire_time) keys.push({ key, expire_time });
        });
        const least_use_key = keys.reduce(
          (min, p) => (p.expire_time < min.expire_time ? p : min),
          keys[0]
        );
        store.remove(least_use_key.key);
      }
    }
  }
  return response;
};
